/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsRemoveById } from "../../funcs/accountsRemoveById.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .DeleteApiLeadScraperMicroserviceApiV1AccountsIdRequest$inboundSchema,
};

export const tool$accountsRemoveById: ToolDefinition<typeof args> = {
  name: "accounts_remove-by-id",
  description: `Delete account

Permanently deletes an account and associated resources`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsRemoveById(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
